module.exports = __webpack_public_path__ + "img/790.81a299e2.png";